import { get } from 'lodash';

import paginationReducerNew from './pagination-new';
import paginationReducerOld from './pagination-old';
import { PAGINATION_USE_NEW_REDUCER } from '../actions/pagination';

const paginationReducer = (state, action) => {
  if (get(action, 'type') === PAGINATION_USE_NEW_REDUCER) {
    return { ...state, useNewReducer: true };
  } else {
    return (get(state, 'useNewReducer') ? paginationReducerNew : paginationReducerOld)(state, action);
  }
};

export default paginationReducer;
